import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative h-[420px] md:h-[600px] w-full overflow-hidden">
      <img
        src="http://biensur.cn/ai/img_res/edited_b84967c0531586d0365179aa8356f096_c7ca86b5.jpg"
        alt="漫蛙 - 在线免费漫画阅读平台"
        title="漫蛙 - 丰富的免费漫画资源"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>

      <div className="relative z-10 h-full w-full max-w-7xl mx-auto px-4 md:px-6 flex flex-col justify-center">
        <div className="w-full">
          <h1 className="text-white font-heading text-3xl md:text-5xl lg:text-6xl font-bold leading-tight mb-4 max-w-2xl">
            海量免费漫画
            <br />
            随时随地畅享
            <br />
            二次元世界
          </h1>
          <p className="text-white/80 text-sm md:text-base max-w-xl mb-8 leading-relaxed">
            热血、恋爱、悬疑、科幻 — 全网最全漫画大全每日更新，蛙蛙陪伴，一键搜索追更。支持夜间阅读模式，Android/iOS客户端下载，享受极致阅读体验。
          </p>
          <div className="flex flex-col sm:flex-row gap-3">
            <Link
              to="/category/rexue"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary-500 text-white rounded-full text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-book-open-line"></i>
              开始阅读
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-white/10 text-white border border-white/30 rounded-full text-sm font-medium hover:bg-white/20 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-information-line"></i>
              了解更多
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}